import moment from 'moment';
import airbrake from './airbrake';
import { localStorage } from './storage';
export var middleware = function middleware() {
  return function (next) {
    return function (action) {
      var result = next(action);
      if (action.cacheUntil) {
        var cachedActionCreators = localStorage.get('cachedActionCreators') || [];
        localStorage.set('cachedActionCreators', cachedActionCreators.concat([action]));
      }
      return result;
    };
  };
};
export var dispatchCachedActionCreators = function dispatchCachedActionCreators(store) {
  var cachedActionCreators = localStorage.get('cachedActionCreators') || [];
  cachedActionCreators.forEach(function (rawActionCreator) {
    var actionCreator = rawActionCreator;
    var valid = moment(actionCreator.cacheUntil).diff(moment()) > 0;
    if (valid) {
      delete actionCreator.cacheUntil;
      try {
        store.dispatch(actionCreator);
      } catch (error) {
        airbrake === null || airbrake === void 0 || airbrake.notify({
          error: error,
          params: {
            actionCreator: actionCreator
          }
        });
      }
    }
  });
  localStorage.remove('cachedActionCreators');
};
export var deleteEntryOfType = function deleteEntryOfType(type) {
  var cachedActionCreators = localStorage.get('cachedActionCreators') || [];
  localStorage.set('cachedActionCreators', cachedActionCreators.filter(function (actionCreator) {
    return actionCreator.type !== type;
  }));
};